"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedPhoneNumberData = exports.PhoneNumberWithContext = exports.CofTags = exports.FideliusTentativeDeviceKey = exports.FideliusClientInit = exports.ErrorData = exports.LoginCodeData = exports.AndroidSafetynetData = exports.AccountLockedData_AppealableLockData = exports.AccountLockedData = exports.ReactivateAccountData = exports.AccountDeactivationData = exports.ChannelVerificationData = exports.TwoFAData = exports.ODLVData = exports.DeviceToken = exports.LoginHeader = exports.AppLoginBootstrapParams = exports.AppLoginContext = exports.AccountLockedData_AppealableLockData_LockSource = exports.AccountDeactivationData_ReactivationStatus = exports.LoginCodeSupportedDeliveryMechanisms = exports.LoginCodeOptInType = exports.LoginCodeType = exports.ChannelVerificationType = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const partial_token_1 = require("../../cdp/cof/partial_token");
const network_tokens_1 = require("../../auth/snaptoken/network_tokens");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** buf:lint:ignore COMMENT_ENUM */
var ChannelVerificationType;
(function (ChannelVerificationType) {
    /** CHANNEL_VERIFICATION_TYPE_UNSET - default value */
    ChannelVerificationType[ChannelVerificationType["CHANNEL_VERIFICATION_TYPE_UNSET"] = 0] = "CHANNEL_VERIFICATION_TYPE_UNSET";
    /** CHANNEL_VERIFICATION_TYPE_EMAIL - verify email */
    ChannelVerificationType[ChannelVerificationType["CHANNEL_VERIFICATION_TYPE_EMAIL"] = 1] = "CHANNEL_VERIFICATION_TYPE_EMAIL";
    ChannelVerificationType[ChannelVerificationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChannelVerificationType = exports.ChannelVerificationType || (exports.ChannelVerificationType = {}));
/** Login code (aka magic code) type used for verification */
var LoginCodeType;
(function (LoginCodeType) {
    /** LOGIN_CODE_TYPE_UNSET - default value */
    LoginCodeType[LoginCodeType["LOGIN_CODE_TYPE_UNSET"] = 0] = "LOGIN_CODE_TYPE_UNSET";
    /** LOGIN_CODE_TYPE_SMS - SMS-based login code */
    LoginCodeType[LoginCodeType["LOGIN_CODE_TYPE_SMS"] = 1] = "LOGIN_CODE_TYPE_SMS";
    /** LOGIN_CODE_TYPE_EMAIL - email-based login code */
    LoginCodeType[LoginCodeType["LOGIN_CODE_TYPE_EMAIL"] = 2] = "LOGIN_CODE_TYPE_EMAIL";
    LoginCodeType[LoginCodeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LoginCodeType = exports.LoginCodeType || (exports.LoginCodeType = {}));
/** determines which UI is used for user to opt in for magic code */
var LoginCodeOptInType;
(function (LoginCodeOptInType) {
    /** LOGIN_CODE_OPT_IN_TYPE_UNSET - default value - no opt in used */
    LoginCodeOptInType[LoginCodeOptInType["LOGIN_CODE_OPT_IN_TYPE_UNSET"] = 0] = "LOGIN_CODE_OPT_IN_TYPE_UNSET";
    /** LOGIN_CODE_PROMPT_TEXT_ERROR - show prompt text error message, based on backend prioritized default delivery mechanism */
    LoginCodeOptInType[LoginCodeOptInType["LOGIN_CODE_PROMPT_TEXT_ERROR"] = 1] = "LOGIN_CODE_PROMPT_TEXT_ERROR";
    /** LOGIN_CODE_OPT_IN_DIALOG - opt in with dialog, based on available delivery strategies. do not show masked credentials */
    LoginCodeOptInType[LoginCodeOptInType["LOGIN_CODE_OPT_IN_DIALOG"] = 2] = "LOGIN_CODE_OPT_IN_DIALOG";
    /** LOGIN_CODE_OPT_IN_DIALOG_MASKED - opt in with dialog, based on available delivery strategies. show masked credentials */
    LoginCodeOptInType[LoginCodeOptInType["LOGIN_CODE_OPT_IN_DIALOG_MASKED"] = 3] = "LOGIN_CODE_OPT_IN_DIALOG_MASKED";
    LoginCodeOptInType[LoginCodeOptInType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LoginCodeOptInType = exports.LoginCodeOptInType || (exports.LoginCodeOptInType = {}));
/** which delivery mechanisms are available for user verification in magic code */
var LoginCodeSupportedDeliveryMechanisms;
(function (LoginCodeSupportedDeliveryMechanisms) {
    /** LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_UNSET - default value */
    LoginCodeSupportedDeliveryMechanisms[LoginCodeSupportedDeliveryMechanisms["LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_UNSET"] = 0] = "LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_UNSET";
    /** LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS_EMAIL - sms and email available for magic code session */
    LoginCodeSupportedDeliveryMechanisms[LoginCodeSupportedDeliveryMechanisms["LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS_EMAIL"] = 1] = "LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS_EMAIL";
    /** LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS - only sms available for magic code */
    LoginCodeSupportedDeliveryMechanisms[LoginCodeSupportedDeliveryMechanisms["LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS"] = 2] = "LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_SMS";
    /** LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_EMAIL - only email available for magic code */
    LoginCodeSupportedDeliveryMechanisms[LoginCodeSupportedDeliveryMechanisms["LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_EMAIL"] = 3] = "LOGIN_CODE_SUPPORTED_DELIVERY_MECHANISMS_EMAIL";
    LoginCodeSupportedDeliveryMechanisms[LoginCodeSupportedDeliveryMechanisms["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LoginCodeSupportedDeliveryMechanisms = exports.LoginCodeSupportedDeliveryMechanisms || (exports.LoginCodeSupportedDeliveryMechanisms = {}));
/** Describes the reactivation status of the account */
var AccountDeactivationData_ReactivationStatus;
(function (AccountDeactivationData_ReactivationStatus) {
    /** UNSET - default value */
    AccountDeactivationData_ReactivationStatus[AccountDeactivationData_ReactivationStatus["UNSET"] = 0] = "UNSET";
    /** DEACTIVATED - the account is deactivated */
    AccountDeactivationData_ReactivationStatus[AccountDeactivationData_ReactivationStatus["DEACTIVATED"] = 1] = "DEACTIVATED";
    /** REACTIVATION_IN_PROGRESS - the account is reactivating */
    AccountDeactivationData_ReactivationStatus[AccountDeactivationData_ReactivationStatus["REACTIVATION_IN_PROGRESS"] = 2] = "REACTIVATION_IN_PROGRESS";
    AccountDeactivationData_ReactivationStatus[AccountDeactivationData_ReactivationStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccountDeactivationData_ReactivationStatus = exports.AccountDeactivationData_ReactivationStatus || (exports.AccountDeactivationData_ReactivationStatus = {}));
/** Describes the source for the account/user lock */
var AccountLockedData_AppealableLockData_LockSource;
(function (AccountLockedData_AppealableLockData_LockSource) {
    /** UNKNOWN_UNSET - default value for the lock source. */
    AccountLockedData_AppealableLockData_LockSource[AccountLockedData_AppealableLockData_LockSource["UNKNOWN_UNSET"] = 0] = "UNKNOWN_UNSET";
    /** AUTOMATED - the lock was enforced by an automated system. */
    AccountLockedData_AppealableLockData_LockSource[AccountLockedData_AppealableLockData_LockSource["AUTOMATED"] = 1] = "AUTOMATED";
    /** HUMAN - the lock was enforced by human intervention. */
    AccountLockedData_AppealableLockData_LockSource[AccountLockedData_AppealableLockData_LockSource["HUMAN"] = 2] = "HUMAN";
    AccountLockedData_AppealableLockData_LockSource[AccountLockedData_AppealableLockData_LockSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccountLockedData_AppealableLockData_LockSource = exports.AccountLockedData_AppealableLockData_LockSource || (exports.AccountLockedData_AppealableLockData_LockSource = {}));
function createBaseAppLoginContext() {
    return {
        blizzardClientId: "",
        loginFlowSessionId: "",
        clientNetworkRequestId: "",
        loginAttemptId: "",
        cofDeviceId: "",
        clientAuthenticationSessionId: "",
        persistentAttestationDeviceId: "",
    };
}
exports.AppLoginContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blizzardClientId !== "") {
            writer.uint32(10).string(message.blizzardClientId);
        }
        if (message.loginFlowSessionId !== "") {
            writer.uint32(18).string(message.loginFlowSessionId);
        }
        if (message.clientNetworkRequestId !== "") {
            writer.uint32(26).string(message.clientNetworkRequestId);
        }
        if (message.loginAttemptId !== "") {
            writer.uint32(34).string(message.loginAttemptId);
        }
        if (message.cofDeviceId !== "") {
            writer.uint32(42).string(message.cofDeviceId);
        }
        if (message.clientAuthenticationSessionId !== "") {
            writer.uint32(50).string(message.clientAuthenticationSessionId);
        }
        if (message.persistentAttestationDeviceId !== "") {
            writer.uint32(58).string(message.persistentAttestationDeviceId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppLoginContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blizzardClientId = reader.string();
                    break;
                case 2:
                    message.loginFlowSessionId = reader.string();
                    break;
                case 3:
                    message.clientNetworkRequestId = reader.string();
                    break;
                case 4:
                    message.loginAttemptId = reader.string();
                    break;
                case 5:
                    message.cofDeviceId = reader.string();
                    break;
                case 6:
                    message.clientAuthenticationSessionId = reader.string();
                    break;
                case 7:
                    message.persistentAttestationDeviceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAppLoginContext();
        message.blizzardClientId = object.blizzardClientId ?? "";
        message.loginFlowSessionId = object.loginFlowSessionId ?? "";
        message.clientNetworkRequestId = object.clientNetworkRequestId ?? "";
        message.loginAttemptId = object.loginAttemptId ?? "";
        message.cofDeviceId = object.cofDeviceId ?? "";
        message.clientAuthenticationSessionId =
            object.clientAuthenticationSessionId ?? "";
        message.persistentAttestationDeviceId =
            object.persistentAttestationDeviceId ?? "";
        return message;
    },
};
function createBaseAppLoginBootstrapParams() {
    return { cofTags: undefined, fideliusClientInit: undefined };
}
exports.AppLoginBootstrapParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cofTags !== undefined) {
            exports.CofTags.encode(message.cofTags, writer.uint32(10).fork()).ldelim();
        }
        if (message.fideliusClientInit !== undefined) {
            exports.FideliusClientInit.encode(message.fideliusClientInit, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppLoginBootstrapParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cofTags = exports.CofTags.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.fideliusClientInit = exports.FideliusClientInit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAppLoginBootstrapParams();
        message.cofTags =
            object.cofTags !== undefined && object.cofTags !== null
                ? exports.CofTags.fromPartial(object.cofTags)
                : undefined;
        message.fideliusClientInit =
            object.fideliusClientInit !== undefined &&
                object.fideliusClientInit !== null
                ? exports.FideliusClientInit.fromPartial(object.fideliusClientInit)
                : undefined;
        return message;
    },
};
function createBaseLoginHeader() {
    return {
        blizzardClientId: "",
        loginFlowSessionId: "",
        authenticationSessionId: "",
        loginAttemptId: "",
        networkRequestId: "",
        cofDeviceId: "",
        cofConfigData: undefined,
        deviceToken: undefined,
        clientAttestationPayload: new Uint8Array(),
        iosDeviceCheckToken: "",
        androidSafetynetAttestation: "",
        vendorAttestationPayloads: [],
    };
}
exports.LoginHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blizzardClientId !== "") {
            writer.uint32(10).string(message.blizzardClientId);
        }
        if (message.loginFlowSessionId !== "") {
            writer.uint32(18).string(message.loginFlowSessionId);
        }
        if (message.authenticationSessionId !== "") {
            writer.uint32(26).string(message.authenticationSessionId);
        }
        if (message.loginAttemptId !== "") {
            writer.uint32(34).string(message.loginAttemptId);
        }
        if (message.networkRequestId !== "") {
            writer.uint32(42).string(message.networkRequestId);
        }
        if (message.cofDeviceId !== "") {
            writer.uint32(50).string(message.cofDeviceId);
        }
        if (message.cofConfigData !== undefined) {
            partial_token_1.PartialToken.encode(message.cofConfigData, writer.uint32(58).fork()).ldelim();
        }
        if (message.deviceToken !== undefined) {
            exports.DeviceToken.encode(message.deviceToken, writer.uint32(82).fork()).ldelim();
        }
        if (message.clientAttestationPayload.length !== 0) {
            writer.uint32(90).bytes(message.clientAttestationPayload);
        }
        if (message.iosDeviceCheckToken !== "") {
            writer.uint32(98).string(message.iosDeviceCheckToken);
        }
        if (message.androidSafetynetAttestation !== "") {
            writer.uint32(106).string(message.androidSafetynetAttestation);
        }
        for (const v of message.vendorAttestationPayloads) {
            writer.uint32(114).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLoginHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blizzardClientId = reader.string();
                    break;
                case 2:
                    message.loginFlowSessionId = reader.string();
                    break;
                case 3:
                    message.authenticationSessionId = reader.string();
                    break;
                case 4:
                    message.loginAttemptId = reader.string();
                    break;
                case 5:
                    message.networkRequestId = reader.string();
                    break;
                case 6:
                    message.cofDeviceId = reader.string();
                    break;
                case 7:
                    message.cofConfigData = partial_token_1.PartialToken.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deviceToken = exports.DeviceToken.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.clientAttestationPayload = reader.bytes();
                    break;
                case 12:
                    message.iosDeviceCheckToken = reader.string();
                    break;
                case 13:
                    message.androidSafetynetAttestation = reader.string();
                    break;
                case 14:
                    message.vendorAttestationPayloads.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLoginHeader();
        message.blizzardClientId = object.blizzardClientId ?? "";
        message.loginFlowSessionId = object.loginFlowSessionId ?? "";
        message.authenticationSessionId = object.authenticationSessionId ?? "";
        message.loginAttemptId = object.loginAttemptId ?? "";
        message.networkRequestId = object.networkRequestId ?? "";
        message.cofDeviceId = object.cofDeviceId ?? "";
        message.cofConfigData =
            object.cofConfigData !== undefined && object.cofConfigData !== null
                ? partial_token_1.PartialToken.fromPartial(object.cofConfigData)
                : undefined;
        message.deviceToken =
            object.deviceToken !== undefined && object.deviceToken !== null
                ? exports.DeviceToken.fromPartial(object.deviceToken)
                : undefined;
        message.clientAttestationPayload =
            object.clientAttestationPayload ?? new Uint8Array();
        message.iosDeviceCheckToken = object.iosDeviceCheckToken ?? "";
        message.androidSafetynetAttestation =
            object.androidSafetynetAttestation ?? "";
        message.vendorAttestationPayloads =
            object.vendorAttestationPayloads?.map((e) => e) || [];
        return message;
    },
};
function createBaseDeviceToken() {
    return { id: "" };
}
exports.DeviceToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeviceToken();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDeviceToken();
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseODLVData() {
    return {
        odlvToken: "",
        emailEnabled: false,
        smsEnabled: false,
        obfuscatedPhone: "",
        obfuscatedEmail: "",
    };
}
exports.ODLVData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.odlvToken !== "") {
            writer.uint32(10).string(message.odlvToken);
        }
        if (message.emailEnabled === true) {
            writer.uint32(16).bool(message.emailEnabled);
        }
        if (message.smsEnabled === true) {
            writer.uint32(24).bool(message.smsEnabled);
        }
        if (message.obfuscatedPhone !== "") {
            writer.uint32(34).string(message.obfuscatedPhone);
        }
        if (message.obfuscatedEmail !== "") {
            writer.uint32(42).string(message.obfuscatedEmail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseODLVData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.odlvToken = reader.string();
                    break;
                case 2:
                    message.emailEnabled = reader.bool();
                    break;
                case 3:
                    message.smsEnabled = reader.bool();
                    break;
                case 4:
                    message.obfuscatedPhone = reader.string();
                    break;
                case 5:
                    message.obfuscatedEmail = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseODLVData();
        message.odlvToken = object.odlvToken ?? "";
        message.emailEnabled = object.emailEnabled ?? false;
        message.smsEnabled = object.smsEnabled ?? false;
        message.obfuscatedPhone = object.obfuscatedPhone ?? "";
        message.obfuscatedEmail = object.obfuscatedEmail ?? "";
        return message;
    },
};
function createBaseTwoFAData() {
    return {
        twoFaToken: "",
        smsEnabled: false,
        otpEnabled: false,
        obfuscatedPhone: "",
    };
}
exports.TwoFAData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.twoFaToken !== "") {
            writer.uint32(10).string(message.twoFaToken);
        }
        if (message.smsEnabled === true) {
            writer.uint32(16).bool(message.smsEnabled);
        }
        if (message.otpEnabled === true) {
            writer.uint32(24).bool(message.otpEnabled);
        }
        if (message.obfuscatedPhone !== "") {
            writer.uint32(34).string(message.obfuscatedPhone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTwoFAData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.twoFaToken = reader.string();
                    break;
                case 2:
                    message.smsEnabled = reader.bool();
                    break;
                case 3:
                    message.otpEnabled = reader.bool();
                    break;
                case 4:
                    message.obfuscatedPhone = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTwoFAData();
        message.twoFaToken = object.twoFaToken ?? "";
        message.smsEnabled = object.smsEnabled ?? false;
        message.otpEnabled = object.otpEnabled ?? false;
        message.obfuscatedPhone = object.obfuscatedPhone ?? "";
        return message;
    },
};
function createBaseChannelVerificationData() {
    return {
        channelVerificationFlowToken: "",
        channelVerificationType: 0,
        inputPrefill: undefined,
    };
}
exports.ChannelVerificationData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelVerificationFlowToken !== "") {
            writer.uint32(10).string(message.channelVerificationFlowToken);
        }
        if (message.channelVerificationType !== 0) {
            writer.uint32(16).int32(message.channelVerificationType);
        }
        if (message.inputPrefill?.$case === "email") {
            writer.uint32(26).string(message.inputPrefill.email);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelVerificationData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.channelVerificationFlowToken = reader.string();
                    break;
                case 2:
                    message.channelVerificationType = reader.int32();
                    break;
                case 3:
                    message.inputPrefill = { $case: "email", email: reader.string() };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseChannelVerificationData();
        message.channelVerificationFlowToken =
            object.channelVerificationFlowToken ?? "";
        message.channelVerificationType = object.channelVerificationType ?? 0;
        if (object.inputPrefill?.$case === "email" &&
            object.inputPrefill?.email !== undefined &&
            object.inputPrefill?.email !== null) {
            message.inputPrefill = {
                $case: "email",
                email: object.inputPrefill.email,
            };
        }
        return message;
    },
};
function createBaseAccountDeactivationData() {
    return {
        reactivationStatus: 0,
        humanReadableMessage: "",
        reactivationToken: "",
    };
}
exports.AccountDeactivationData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reactivationStatus !== 0) {
            writer.uint32(8).int32(message.reactivationStatus);
        }
        if (message.humanReadableMessage !== "") {
            writer.uint32(18).string(message.humanReadableMessage);
        }
        if (message.reactivationToken !== "") {
            writer.uint32(26).string(message.reactivationToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccountDeactivationData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reactivationStatus = reader.int32();
                    break;
                case 2:
                    message.humanReadableMessage = reader.string();
                    break;
                case 3:
                    message.reactivationToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAccountDeactivationData();
        message.reactivationStatus = object.reactivationStatus ?? 0;
        message.humanReadableMessage = object.humanReadableMessage ?? "";
        message.reactivationToken = object.reactivationToken ?? "";
        return message;
    },
};
function createBaseReactivateAccountData() {
    return { humanReadableMessage: "" };
}
exports.ReactivateAccountData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.humanReadableMessage !== "") {
            writer.uint32(10).string(message.humanReadableMessage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactivateAccountData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.humanReadableMessage = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseReactivateAccountData();
        message.humanReadableMessage = object.humanReadableMessage ?? "";
        return message;
    },
};
function createBaseAccountLockedData() {
    return {
        humanReadableMessage: "",
        isAppealable: false,
        appealableLockData: undefined,
    };
}
exports.AccountLockedData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.humanReadableMessage !== "") {
            writer.uint32(18).string(message.humanReadableMessage);
        }
        if (message.isAppealable === true) {
            writer.uint32(24).bool(message.isAppealable);
        }
        if (message.appealableLockData !== undefined) {
            exports.AccountLockedData_AppealableLockData.encode(message.appealableLockData, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccountLockedData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.humanReadableMessage = reader.string();
                    break;
                case 3:
                    message.isAppealable = reader.bool();
                    break;
                case 4:
                    message.appealableLockData =
                        exports.AccountLockedData_AppealableLockData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAccountLockedData();
        message.humanReadableMessage = object.humanReadableMessage ?? "";
        message.isAppealable = object.isAppealable ?? false;
        message.appealableLockData =
            object.appealableLockData !== undefined &&
                object.appealableLockData !== null
                ? exports.AccountLockedData_AppealableLockData.fromPartial(object.appealableLockData)
                : undefined;
        return message;
    },
};
function createBaseAccountLockedData_AppealableLockData() {
    return {
        accountLockReason: "",
        accountLockSource: "",
        accountLockTimestampMillis: "0",
        snapSessionResponse: undefined,
        verifiedEmail: "",
        username: "",
        lockSource: 0,
        isDmdAccessBlocked: false,
        localizedLockReason: "",
    };
}
exports.AccountLockedData_AppealableLockData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.accountLockReason !== "") {
            writer.uint32(10).string(message.accountLockReason);
        }
        if (message.accountLockSource !== "") {
            writer.uint32(18).string(message.accountLockSource);
        }
        if (message.accountLockTimestampMillis !== "0") {
            writer.uint32(24).int64(message.accountLockTimestampMillis);
        }
        if (message.snapSessionResponse !== undefined) {
            network_tokens_1.SnapSessionResponse.encode(message.snapSessionResponse, writer.uint32(34).fork()).ldelim();
        }
        if (message.verifiedEmail !== "") {
            writer.uint32(42).string(message.verifiedEmail);
        }
        if (message.username !== "") {
            writer.uint32(50).string(message.username);
        }
        if (message.lockSource !== 0) {
            writer.uint32(56).int32(message.lockSource);
        }
        if (message.isDmdAccessBlocked === true) {
            writer.uint32(64).bool(message.isDmdAccessBlocked);
        }
        if (message.localizedLockReason !== "") {
            writer.uint32(74).string(message.localizedLockReason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccountLockedData_AppealableLockData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accountLockReason = reader.string();
                    break;
                case 2:
                    message.accountLockSource = reader.string();
                    break;
                case 3:
                    message.accountLockTimestampMillis = longToString(reader.int64());
                    break;
                case 4:
                    message.snapSessionResponse = network_tokens_1.SnapSessionResponse.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.verifiedEmail = reader.string();
                    break;
                case 6:
                    message.username = reader.string();
                    break;
                case 7:
                    message.lockSource = reader.int32();
                    break;
                case 8:
                    message.isDmdAccessBlocked = reader.bool();
                    break;
                case 9:
                    message.localizedLockReason = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAccountLockedData_AppealableLockData();
        message.accountLockReason = object.accountLockReason ?? "";
        message.accountLockSource = object.accountLockSource ?? "";
        message.accountLockTimestampMillis =
            object.accountLockTimestampMillis ?? "0";
        message.snapSessionResponse =
            object.snapSessionResponse !== undefined &&
                object.snapSessionResponse !== null
                ? network_tokens_1.SnapSessionResponse.fromPartial(object.snapSessionResponse)
                : undefined;
        message.verifiedEmail = object.verifiedEmail ?? "";
        message.username = object.username ?? "";
        message.lockSource = object.lockSource ?? 0;
        message.isDmdAccessBlocked = object.isDmdAccessBlocked ?? false;
        message.localizedLockReason = object.localizedLockReason ?? "";
        return message;
    },
};
function createBaseAndroidSafetynetData() {
    return { nonce: new Uint8Array() };
}
exports.AndroidSafetynetData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nonce.length !== 0) {
            writer.uint32(10).bytes(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAndroidSafetynetData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAndroidSafetynetData();
        message.nonce = object.nonce ?? new Uint8Array();
        return message;
    },
};
function createBaseLoginCodeData() {
    return {
        numDigits: 0,
        sessionToken: new Uint8Array(),
        promptText: "",
        deliveryMechanism: 0,
        originalAttemptErrorData: undefined,
        optInType: 0,
        supportedDeliveryMechanisms: 0,
        maskedPhoneNumber: "",
        maskedEmail: "",
    };
}
exports.LoginCodeData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.numDigits !== 0) {
            writer.uint32(8).uint32(message.numDigits);
        }
        if (message.sessionToken.length !== 0) {
            writer.uint32(18).bytes(message.sessionToken);
        }
        if (message.promptText !== "") {
            writer.uint32(26).string(message.promptText);
        }
        if (message.deliveryMechanism !== 0) {
            writer.uint32(32).int32(message.deliveryMechanism);
        }
        if (message.originalAttemptErrorData !== undefined) {
            exports.ErrorData.encode(message.originalAttemptErrorData, writer.uint32(42).fork()).ldelim();
        }
        if (message.optInType !== 0) {
            writer.uint32(48).int32(message.optInType);
        }
        if (message.supportedDeliveryMechanisms !== 0) {
            writer.uint32(56).int32(message.supportedDeliveryMechanisms);
        }
        if (message.maskedPhoneNumber !== "") {
            writer.uint32(66).string(message.maskedPhoneNumber);
        }
        if (message.maskedEmail !== "") {
            writer.uint32(74).string(message.maskedEmail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLoginCodeData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.numDigits = reader.uint32();
                    break;
                case 2:
                    message.sessionToken = reader.bytes();
                    break;
                case 3:
                    message.promptText = reader.string();
                    break;
                case 4:
                    message.deliveryMechanism = reader.int32();
                    break;
                case 5:
                    message.originalAttemptErrorData = exports.ErrorData.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.optInType = reader.int32();
                    break;
                case 7:
                    message.supportedDeliveryMechanisms = reader.int32();
                    break;
                case 8:
                    message.maskedPhoneNumber = reader.string();
                    break;
                case 9:
                    message.maskedEmail = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLoginCodeData();
        message.numDigits = object.numDigits ?? 0;
        message.sessionToken = object.sessionToken ?? new Uint8Array();
        message.promptText = object.promptText ?? "";
        message.deliveryMechanism = object.deliveryMechanism ?? 0;
        message.originalAttemptErrorData =
            object.originalAttemptErrorData !== undefined &&
                object.originalAttemptErrorData !== null
                ? exports.ErrorData.fromPartial(object.originalAttemptErrorData)
                : undefined;
        message.optInType = object.optInType ?? 0;
        message.supportedDeliveryMechanisms =
            object.supportedDeliveryMechanisms ?? 0;
        message.maskedPhoneNumber = object.maskedPhoneNumber ?? "";
        message.maskedEmail = object.maskedEmail ?? "";
        return message;
    },
};
function createBaseErrorData() {
    return { humanReadableErrorMessage: "" };
}
exports.ErrorData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.humanReadableErrorMessage !== "") {
            writer.uint32(10).string(message.humanReadableErrorMessage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseErrorData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.humanReadableErrorMessage = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseErrorData();
        message.humanReadableErrorMessage = object.humanReadableErrorMessage ?? "";
        return message;
    },
};
function createBaseFideliusClientInit() {
    return { hashedPublicKeys: [], tentativeDeviceKey: undefined };
}
exports.FideliusClientInit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.hashedPublicKeys) {
            writer.uint32(10).bytes(v);
        }
        if (message.tentativeDeviceKey !== undefined) {
            exports.FideliusTentativeDeviceKey.encode(message.tentativeDeviceKey, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFideliusClientInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hashedPublicKeys.push(reader.bytes());
                    break;
                case 2:
                    message.tentativeDeviceKey = exports.FideliusTentativeDeviceKey.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFideliusClientInit();
        message.hashedPublicKeys = object.hashedPublicKeys?.map((e) => e) || [];
        message.tentativeDeviceKey =
            object.tentativeDeviceKey !== undefined &&
                object.tentativeDeviceKey !== null
                ? exports.FideliusTentativeDeviceKey.fromPartial(object.tentativeDeviceKey)
                : undefined;
        return message;
    },
};
function createBaseFideliusTentativeDeviceKey() {
    return {
        publicKey: new Uint8Array(),
        hashedPublicKey: new Uint8Array(),
        iwek: new Uint8Array(),
        version: "0",
    };
}
exports.FideliusTentativeDeviceKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.publicKey.length !== 0) {
            writer.uint32(10).bytes(message.publicKey);
        }
        if (message.hashedPublicKey.length !== 0) {
            writer.uint32(18).bytes(message.hashedPublicKey);
        }
        if (message.iwek.length !== 0) {
            writer.uint32(26).bytes(message.iwek);
        }
        if (message.version !== "0") {
            writer.uint32(32).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFideliusTentativeDeviceKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.publicKey = reader.bytes();
                    break;
                case 2:
                    message.hashedPublicKey = reader.bytes();
                    break;
                case 3:
                    message.iwek = reader.bytes();
                    break;
                case 4:
                    message.version = longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFideliusTentativeDeviceKey();
        message.publicKey = object.publicKey ?? new Uint8Array();
        message.hashedPublicKey = object.hashedPublicKey ?? new Uint8Array();
        message.iwek = object.iwek ?? new Uint8Array();
        message.version = object.version ?? "0";
        return message;
    },
};
function createBaseCofTags() {
    return { routeTag: "", eTag: "", lenscoreVersion: 0 };
}
exports.CofTags = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.routeTag !== "") {
            writer.uint32(10).string(message.routeTag);
        }
        if (message.eTag !== "") {
            writer.uint32(18).string(message.eTag);
        }
        if (message.lenscoreVersion !== 0) {
            writer.uint32(24).int32(message.lenscoreVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCofTags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.routeTag = reader.string();
                    break;
                case 2:
                    message.eTag = reader.string();
                    break;
                case 3:
                    message.lenscoreVersion = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCofTags();
        message.routeTag = object.routeTag ?? "";
        message.eTag = object.eTag ?? "";
        message.lenscoreVersion = object.lenscoreVersion ?? 0;
        return message;
    },
};
function createBasePhoneNumberWithContext() {
    return {
        countryCode: "",
        simCountryCode: "",
        rawPhoneNumber: "",
        bypassParsing: false,
    };
}
exports.PhoneNumberWithContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.countryCode !== "") {
            writer.uint32(10).string(message.countryCode);
        }
        if (message.simCountryCode !== "") {
            writer.uint32(18).string(message.simCountryCode);
        }
        if (message.rawPhoneNumber !== "") {
            writer.uint32(26).string(message.rawPhoneNumber);
        }
        if (message.bypassParsing === true) {
            writer.uint32(32).bool(message.bypassParsing);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePhoneNumberWithContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.countryCode = reader.string();
                    break;
                case 2:
                    message.simCountryCode = reader.string();
                    break;
                case 3:
                    message.rawPhoneNumber = reader.string();
                    break;
                case 4:
                    message.bypassParsing = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePhoneNumberWithContext();
        message.countryCode = object.countryCode ?? "";
        message.simCountryCode = object.simCountryCode ?? "";
        message.rawPhoneNumber = object.rawPhoneNumber ?? "";
        message.bypassParsing = object.bypassParsing ?? false;
        return message;
    },
};
function createBaseFormattedPhoneNumberData() {
    return { isoCountryCode: "", phoneNumber: "" };
}
exports.FormattedPhoneNumberData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isoCountryCode !== "") {
            writer.uint32(10).string(message.isoCountryCode);
        }
        if (message.phoneNumber !== "") {
            writer.uint32(18).string(message.phoneNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormattedPhoneNumberData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isoCountryCode = reader.string();
                    break;
                case 2:
                    message.phoneNumber = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFormattedPhoneNumberData();
        message.isoCountryCode = object.isoCountryCode ?? "";
        message.phoneNumber = object.phoneNumber ?? "";
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=login_common.js.map